import Vue from 'vue';
import Router from 'vue-router';
import store from '@/vuex';
import { Message } from 'element-ui'
const load = (path) => { // 路由懒加载
    return () => Promise.resolve(require(`@/views/${path}`).default)
}
const $import = (path) => { // 直接加载
    return () => import(`@/views/${path}`)
}

/* 登录页 */
import home2 from '@/views/home/home2.vue'
import Login from '@/views/home/Login.vue'
import LoginNew from '@/views/home/loginNew.vue'

/* 官网页面（/home、/product/*、/compare、/about） */
import siteApp from '@site/App.vue'
import HomeView from '@site/views/HomeView.vue'
import StandardProductView from '@site/views/StandardProductView.vue'
import NovaProductView from '@site/views/NovaProductView.vue'
import CompareView from '@site/views/CompareView.vue'
import AboutView from '@site/views/AboutView.vue'

import NProgress from 'nprogress';

const Home = load('homenew/Home.vue');
const saleOrder = load('saleOrder/index.vue');
const goodsSaleOrder = load('goodsSaleOrder/index.vue');
const returnOrder = load('returnOrder/index.vue');
const goodsReturnOrder = load('goodsReturnOrder/index.vue');
const shopJYZL = load('shopJYZL/index.vue');
const storePayment = load('storePayment/index.vue');
const commodityInfo = load('commodityInfo/index.vue');
const memberRecharge = load('memberRecharge/index.vue');
const employeeCommission = load('employeeCommission/index.vue');
const employeeBilling = load('employeeBilling/index.vue');
const product = load('product/index.vue');
//新增员工交接班
const employeeHandover = load('employeeHandover/index.vue');
//网店订单
const wdOrder = load('wdOrder/index.vue');
const wdStatistics = load('wdStatistics/index.vue');

// 门店收银系统
const padHome = load('padViews/home/Home.vue');
const padLogin = load('padViews/Login.vue');
const padLogin2 = load('padViews/Login2.vue');
/**店铺激活页 */
/**主页 */
const mainPage = load('padViews/mainPage/mainPage.vue');
/**商品 */
const PadProduct = load('padViews/product/product.vue');
const addProduct = load('padViews/product/addProduct.vue');
const viewProduct = load('padViews/product/viewProduct.vue');
const editProduct = load('padViews/product/editProduct.vue');
/**会员 */
const vip = load('padViews/vip/vip.vue');
const vipDetail = load('padViews/vip/vipDetail.vue');
const vipRecharge = load('padViews/vip/vipRecharge.vue');
/**员工 */
const staff = load('padViews/staff/staff.vue');
/**库存 */
const stock = load('padViews/stock/stock.vue');
const addInventory = load('padViews/stock/addInventory.vue');
const addFullInventory = load('padViews/stock/addFullInventory.vue');
const fullInventoryDetail = load('padViews/stock/fullInventoryDetail.vue');
/**收银台 */
const cashierPad = load('padViews/cashier/cashier.vue');
const changeOrderDetail = load('padViews/cashier/changeOrderDetail.vue');
const onlineOrderDetail = load('padViews/cashier/onlineOrderDetail.vue');
/**调拨 */
const allot = load('padViews/allot/allot.vue');
const addAllot = load('padViews/allot/addAllot.vue');
const viewAllot = load('padViews/allot/viewAllot.vue');
/**交接班 */
const changeShifts = load('padViews/changeShifts/changeShifts.vue');
// 公告
const notice = load('padViews/notice/notice.vue');
/**报表 */
const report = load('padViews/report/report.vue');
/**设置 */
const setting = load('padViews/setting/setting.vue');
const chooseBlue = load('padViews/setting/chooseBlue.vue');
/**店铺激活页 */
const shopUpdate = load('padViews/shopUpdate.vue');
/**隐私协议 */
const protocol = load('padViews/protocol/protocol.vue');
const protocolPrivacy = load('padViews/protocolPrivacy/protocolPrivacy.vue');
/**internalH5 */
const inLogin = load('internalH5/Login.vue');
const abnormalList = load('internalH5/abnormalList.vue');
const abnormalDetail = load('internalH5/abnormalDetail.vue');

Vue.use(Router);
let constRouters = [
    {
        path: '/',
        hidden: true,
        redirect: {
            name: 'home'
        }
    },
    {
        path: '',
        name: 'site',
        component: siteApp,
        hidden: true,
        children: [
            {
                path: '/home',
                name: 'home',
                component: HomeView,
                meta: { title: '首页' }
            },
            {
                path: '/product/standard',
                name: 'product-standard',
                component: StandardProductView,
                meta: { title: '航富通标准版' }
            },
            {
                path: '/product/nova',
                name: 'product-nova',
                component: NovaProductView,
                meta: { title: '航富通 Nova' }
            },
            {
                path: '/compare',
                name: 'compare',
                component: CompareView,
                meta: { title: '套餐对比' }
            },
            {
                path: '/about',
                name: 'about',
                component: AboutView,
                meta: { title: '关于我们' }
            },
        ]
    },
    {
        path: '/home2',
        name: 'home2',
        component: home2,
        hidden: true,
        meta: {
            title: '首页'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        hidden: true,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/padHome',
        name: 'padHome',
        component: padHome,
        hidden: true,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/LoginNew',
        name: 'LoginNew',
        component: LoginNew,
        hidden: true,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/pad',
        hidden: true,
        redirect: {
            name: 'padLogin' 
        }
    },
    {
        path: '/pad/padLogin',
        name: 'padLogin',
        component: padLogin,
        hidden: true,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/pad/padLogin2',
        name: 'padLogin2',
        component: padLogin2,
        hidden: true,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/pad/shopUpdate',
        name: 'shopUpdate',
        component: shopUpdate,
        hidden: true,
        meta: {
            title: '激活页'
        }
    },
    {
        path: '/pad/protocol',
        name: 'protocol',
        component: protocol,
        hidden: true,
        meta: {
            title: '服务协议'
        }
    },
    {
        path: '/pad/protocolPrivacy',
        name: 'protocolPrivacy',
        component: protocolPrivacy,
        hidden: true,
        meta: {
            title: '隐私政策'
        }
    },
    {
        path: '/internal',
        hidden: true,
        redirect: {
            name: 'inLogin' 
        }
    },
    {
        path: '/internal/login',
        name: 'inLogin',
        component: inLogin,
        hidden: true,
        meta: {
            title: '登录'
        }
    },
];
export let permissonRoutes = [
    {
        path: '/product',
        component: Home,
        leaf: true, //只有一个节点
        name: '商品信息',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/51ACE926-AE30-4447-9686-CF0B8379200E.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/3B945B3C-06D7-455D-AE8E-BCE688CD26EE.png',
        type: 1,
        meta: {
            actindex: 12,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '商品信息'
        },
        children: [
            {
                path: '/product/index',
                name: '商品信息',
                component: product,
                meta: {
                    actindex: 12,
                    title: '商品信息',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/saleOrder',
        component: Home,
        leaf: true, //只有一个节点
        name: '销售订单',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/E01FEC41-AF87-4B44-BE8A-7317CCA517F1.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/FD651156-BAD5-4B0D-B84F-BC7F5C965B7F.png',
        type: 1,
        meta: {
            actindex: 13,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '销售订单'
        },
        children: [
            {
                path: '/saleOrder/index',
                name: '销售订单',
                component: saleOrder,
                meta: {
                    actindex: 13,
                    title: '销售订单',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/goodsSaleOrder',
        component: Home,
        leaf: true, //只有一个节点
        name: '商品销售报表',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/7B0C303C-AC6B-4514-B379-56D0C3DAA2E7.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/BB0CCAA3-FEC0-4613-98E3-45B55D549516.png',
        type: 1,
        meta: {
            actindex: 14,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '商品销售报表'
        },
        children: [
            {
                path: '/goodsSaleOrder/index',
                name: '商品销售报表',
                component: goodsSaleOrder,
                meta: {
                    actindex: 14,
                    title: '商品销售报表',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/returnOrder',
        component: Home,
        leaf: true, //只有一个节点
        name: '退货订单',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/58237AB4-127E-41CF-A107-908FB1F294D6.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/76DF5010-3E83-4DA6-BB61-5230D51BFE16.png',
        type: 1,
        meta: {
            actindex: 15,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '退货订单'
        },
        children: [
            {
                path: '/returnOrder/index',
                name: '退货订单',
                component: returnOrder,
                meta: {
                    actindex: 15,
                    title: '退货订单',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/goodsReturnOrder',
        component: Home,
        leaf: true, //只有一个节点
        name: '商品退回报表',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/7B0C303C-AC6B-4514-B379-56D0C3DAA2E7.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/BB0CCAA3-FEC0-4613-98E3-45B55D549516.png',
        type: 1,
        meta: {
            actindex: 16,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '商品退回报表'
        },
        children: [
            {
                path: '/goodsReturnOrder/index',
                name: '商品退回报表',
                component: goodsReturnOrder,
                meta: {
                    actindex: 16,
                    title: '商品退回报表',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/shopJYZL',
        component: Home,
        leaf: true, //只有一个节点
        name: '门店交易总览',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/F5D974A8-FABD-4C74-A960-D3FED355C1F1.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/2536A2D7-FCFB-46E8-A5F4-F6BED943CA84.png',
        type: 1,
        meta: {
            actindex: 17,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '门店交易总览'
        },
        children: [
            {
                path: '/shopJYZL/index',
                name: '门店交易总览',
                component: shopJYZL,
                meta: {
                    actindex: 17,
                    title: '门店交易总览',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/storePayment',
        component: Home,
        leaf: true, //只有一个节
        name: '门店支付总览',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/DE3C1C06-156C-46E3-A2DD-FCB19E8D6424.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/4637E2C7-3AEF-4F21-BB00-4FF7B42B89CA.png',
        type: 1,
        meta: {
            actindex: 18,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '门店支付总览'
        },
        children: [
            {
                path: '/storePayment/index',
                name: '门店支付总览',
                component: storePayment,
                meta: {
                    actindex: 18,
                    title: '门店支付总览',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/commodityInfo',
        component: Home,
        leaf: true, //只有一个节点
        name: '商品库存报表',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/928E7100-891D-4913-8C66-A89D36892D8A.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/882FD9AB-3224-4CCA-82BB-E4DD4A19274D.png',
        type: 1,
        meta: {
            actindex: 19,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '商品库存报表'
        },
        children: [
            {
                path: '/commodityInfo/index',
                name: '商品库存报表',
                component: commodityInfo,
                meta: {
                    actindex: 19,
                    title: '商品库存报表',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/memberRecharge',
        component: Home,
        leaf: true, //只有一个节点
        name: '会员充值报表',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/7F609E39-9EF2-4644-A1FA-9AF19BAA9EC2.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/232D0DCC-8B52-43D7-A116-A2ED490646AD.png',
        type: 1,
        meta: {
            actindex: 20,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '会员充值报表'
        },
        children: [
            {
                path: '/memberRecharge/index',
                name: '会员充值报表',
                component: memberRecharge,
                meta: {
                    actindex: 20,
                    title: '会员充值报表',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/employeeCommission',
        component: Home,
        leaf: true, //只有一个节点
        name: '员工提成报表',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/048B5F0D-E22A-4DBC-8CF6-34053CFAC59B.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/99A0B58D-7381-4338-A567-F0D2BF2CB84F.png',
        type: 1,
        meta: {
            actindex: 21,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '员工提成报表'
        },
        children: [
            {
                path: '/employeeCommission/index',
                name: '员工提成报表',
                component: employeeCommission,
                meta: {
                    actindex: 21,
                    title: '员工提成报表',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/employeeBilling',
        component: Home,
        leaf: true, //只有一个节点
        name: '员工开单明细',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/51ACE926-AE30-4447-9686-CF0B8379200E.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/3B945B3C-06D7-455D-AE8E-BCE688CD26EE.png',
        type: 1,
        meta: {
            actindex: 22,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '员工开单明细'
        },
        children: [
            {
                path: '/employeeBilling/index',
                name: '员工开单明细',
                component: employeeBilling,
                meta: {
                    actindex: 22,
                    title: '员工开单明细',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/employeeHandover',
        component: Home,
        leaf: true, //只有一个节点
        name: '员工交接班报表',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/51ACE926-AE30-4447-9686-CF0B8379200E.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/3B945B3C-06D7-455D-AE8E-BCE688CD26EE.png',
        type: 1,
        meta: {
            actindex: 23,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '员工交接班报表'
        },
        children: [
            {
                path: '/employeeHandover/index',
                name: '员工交接班报表',
                component: employeeHandover,
                meta: {
                    actindex: 23,
                    title: '员工交接班报表',
                    alias: ['6qxh6']
                },
            },
        ]
    },
    {
        path: '/wdOrder',
        component: Home,
        leaf: true, //只有一个节点
        name: '网店订单',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/E01FEC41-AF87-4B44-BE8A-7317CCA517F1.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/FD651156-BAD5-4B0D-B84F-BC7F5C965B7F.png',
        type: 1,
        meta: {
            actindex: 24,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '网店订单'
        },
        children: [
            {
                path: '/wdOrder/index',
                name: '网店订单',
                component: wdOrder,
                meta: {
                    actindex: 24,
                    title: '网店订单',
                    alias: ['6qxh6']
                },
                
            },
        ],
        childtype:1
    },
    {
        path: '/wdStatistics',
        component: Home,
        leaf: true, //只有一个节点
        name: '网店销售统计',
        icon: 'icon-a-rongqi125',
        src: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/048B5F0D-E22A-4DBC-8CF6-34053CFAC59B.png',
        src2: 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/99A0B58D-7381-4338-A567-F0D2BF2CB84F.png',
        type: 1,
        meta: {
            actindex: 25,
            alias: ['6547u', 'g81hy', 'mwr9n', '4t979', '0n6dr', '6qxh6', '6ndeq'],
            title: '网店销售统计'
        },
        children: [
            {
                path: '/wdStatistics/index',
                name: '网店销售统计',
                component: wdStatistics,
                meta: {
                    actindex: 25,
                    title: '网店销售统计',
                    alias: ['6qxh6']
                },
                
            },
        ],
        childtype:1
    },

    {
        path: '/pad/mainPage',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '主页'
        },
        children: [
            {
                path: '/pad/mainPage/index',
                component: mainPage,
                name: '主页',
                meta: {
                    title: '主页'
                }
            },

        ]
    },
    {
        path: '/pad/product',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '商品'
        },
        children: [
            {
                path: '/pad/product/index',
                component: PadProduct,
                name: '商品',
                meta: {
                    title: '商品',
                    keepAlive: true,
                }
            },
            {
                path: '/pad/product/addProduct',
                component: addProduct,
                name: '新增商品',
                meta: {
                    title: '新增商品'
                }
            },
            {
                path: '/pad/product/viewProduct',
                component: viewProduct,
                name: '商品详情',
                meta: {
                    title: '商品详情'
                }
            },
            {
                path: '/pad/product/editProduct',
                component: editProduct,
                name: '编辑商品',
                meta: {
                    title: '编辑商品'
                }
            },

        ]
    },
    {
        path: '/pad/vip',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '会员'
        },
        children: [
            {
                path: '/pad/vip/index',
                component: vip,
                name: '会员',
                meta: {
                    keepAlive: true,
                    title: '会员'
                }
            },
            {
                path: '/pad/vip/detail',
                component: vipDetail,
                name: '会员明细',
                meta: {
                    title: '会员明细'
                }
            },
            {
                path: '/pad/vip/recharge',
                component: vipRecharge,
                name: '会员充值',
                meta: {
                    title: '会员充值'
                }
            },


        ]
    },
    {
        path: '/pad/staff',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '员工'
        },
        children: [
            {
                path: '/pad/staff/index',
                component: staff,
                name: '员工',
                meta: {
                    title: '员工'
                }
            },


        ]
    },
    {
        path: '/pad/stock',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '库存'
        },
        children: [
            {
                path: '/pad/stock/index',
                component: stock,
                name: '库存',
                meta: {
                    title: '库存'
                }
            },
            {
                path: '/pad/stock/addInventory',
                component: addInventory,
                name: '库存盘点',
                meta: {
                    title: '库存'
                }
            },
            {
                path: '/pad/stock/addFullInventory',
                component: addFullInventory,
                name: '库存盘点',
                meta: {
                    title: '库存'
                }
            },
            {
                path: '/pad/stock/fullInventoryDetail',
                component: fullInventoryDetail,
                name: '全库盘点单详情',
                meta: {
                    title: '库存'
                }
            },


        ]
    },
    {
        path: '/pad/cashier',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '收银台'
        },
        children: [
            {
                path: '/pad/cashier/index',
                component: cashierPad,
                name: '收银台',
                meta: {
                    title: '收银台'
                }
            },
            {
                path: '/pad/cashier/changeOrderDetail',
                component: changeOrderDetail,
                name: '换货详情',
                meta: {
                    title: '换货详情'
                }
            },
            {
                path: '/pad/cashier/onlineOrderDetail',
                component: onlineOrderDetail,
                name: '网店订单详情',
                meta: {
                    title: '网店订单详情'
                }
            },
        ]
    },
    {
        path: '/pad/allot',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '调拨'
        },
        children: [
            {
                path: '/pad/allot/index',
                component: allot,
                name: '调拨',
                meta: {
                    title: '调拨'
                }
            },
            {
                path: '/pad/allot/addAllot',
                component: addAllot,
                name: '新增调拨出库',
                meta: {
                    title: '新增调拨出库'
                }
            },
            {
                path: '/pad/allot/viewAllot',
                component: viewAllot,
                name: '调拨单详情',
                meta: {
                    title: '调拨单详情'
                }
            },
        ]
    },
    {
        path: '/pad/changeShifts',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '交接班'
        },
        children: [
            {
                path: '/pad/changeShifts/index',
                component: changeShifts,
                name: '交接班',
                meta: {
                    title: '交接班'
                }
            },
        ]
    },
    {
        path: '/pad/notice',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '公告'
        },
        children: [
            {
                path: '/pad/notice/index',
                component: notice,
                name: '公告',
                meta: {
                    title: '公告'
                }
            },
        ]
    },
    {
        path: '/pad/report',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '报表'
        },
        children: [
            {
                path: '/pad/report/index',
                component: report,
                name: '报表',
                meta: {
                    title: '报表'
                }
            },
        ]
    },
    {
        path: '/pad/setting',
        component: padHome,
        leaf: true, //只有一个节点
        meta: {
            title: '设置'
        },
        children: [
            {
                path: '/pad/setting/index',
                component: setting,
                name: '设置',
                meta: {
                    title: '设置',
                    keepAlive: true,
                }
            },
            {
                path: '/pad/setting/chooseBlue',
                component: chooseBlue,
                name: '蓝牙打印机',
                meta: {
                    title: '蓝牙打印机'
                }
            },
        ]
    },
    {
        path: '/internal/abnormalList',
        name: 'abnormalList',
        component: abnormalList,
        hidden: true,
        meta: {
            title: '异常订单'
        }
    },
    {
        path: '/internal/abnormalDetail',
        name: 'abnormalDetail',
        component: abnormalDetail,
        hidden: true,
        meta: {
            title: '异常订单详情'
        }
    },
]


const router = new Router({
    routes: constRouters,
});

/**
 * 递归查询
 */
let routerlist = []
let hasrouter = false
let routergo = ''
/**路由过滤 */
let filterHandler = (arr) => {
    let childernList = []
    let list = arr.filter(v => {
        if (v.children && v.children.length !== 0) {
            childernList = filterHandler(v.children)
        }
        if (routerlist.indexOf(v.name) !== -1) {
            hasrouter = v.path == routergo
        }
        childernList.length > 0 ? v.children = childernList : null

        return routerlist.indexOf(v.name) !== -1 || childernList.length !== 0
    })
    return list
}
/**
 * 过滤路由
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.auth) {
        return roles.some(role => route.meta.auth.includes(role));
    } else {
        return true;
    }
}

function hasRoute(routes, path) {
    if (JSON.stringify(routes).includes(path)) {
        return true;
    } else {
        return false;
    }
}
// 免登录路径
const whitelist = ['/home', '/home2', '/login', '/LoginNew', '/pad/padLogin', '/pad/padLogin2','/internal/login', '/product/standard', '/product/nova', '/compare', '/about'];
// 避免无权限时重复生成路由
var filterRoutes = [];
router.beforeEach(async (to, from, next) => {
    console.log('to', to);

    /**pc */
    // filterRoutes = []
    // if (whitelist.indexOf(to.path) !== -1) {
    //     next()
    // } else {
    //     next({ path: `/home?redirect=${to.path}`, replace: true })
    //     NProgress.done()
    // }
    let isPad = localStorage.getItem("isPad");
    console.log('isPad', isPad);
    if(to.path.indexOf('/pad')>-1){
        let hasToken = null
        let dayChecked = localStorage.getItem('isRememberPwd')
        if (dayChecked == 'true') {
            hasToken = localStorage.getItem('padToken');
        }else {
            hasToken = localStorage.getItem('padToken');
        }
        if (hasToken) {
            console.log('to.path1', to.path)
    
            if (to.path === '/pad/padLogin') {
                next()
                NProgress.done()
            } else {
                console.log('filterRoutes', filterRoutes)
    
                if (filterRoutes.length == 0) {
                    // let getjurisdictionlist = store.getters['login/getjurisdiction'];
                    // let filterlist = await  store.dispatch('login/generateRoutes',getjurisdictionlist)
                    router["options"].routes = [...constRouters, ...permissonRoutes];
                    filterRoutes = [...constRouters, ...permissonRoutes];
                    router.addRoutes(filterRoutes);
                    next({
                        name: to.name,
                        path: to.path,
                        hash: to.hash,
                        query: to.query,
                        params: to.params,
                        append: false,
                        replace: true
                    });
                } else {
                    next()
                }
            }
        } else {
            filterRoutes = []
            console.log('to.path2', to.path)
            if (whitelist.indexOf(to.path) !== -1 ) {
                next()
            } else {
                next({ path: `/pad/padLogin?redirect=${to.path}`, replace: true })
                NProgress.done()
            }
        }

    }else if(to.path.indexOf('/internal')>-1){
        let hasToken = null
        hasToken = localStorage.getItem('internalToken');
        if (hasToken) {
            if (to.path === '/internal/login') {
                next()
                NProgress.done()
            } else {
    
                if (filterRoutes.length == 0) {
                    // let getjurisdictionlist = store.getters['login/getjurisdiction'];
                    // let filterlist = await  store.dispatch('login/generateRoutes',getjurisdictionlist)
                    router["options"].routes = [...constRouters, ...permissonRoutes];
                    filterRoutes = [...constRouters, ...permissonRoutes];
                    router.addRoutes(filterRoutes);
                    next({
                        name: to.name,
                        path: to.path,
                        hash: to.hash,
                        query: to.query,
                        params: to.params,
                        append: false,
                        replace: true
                    });
                } else {
                    next()
                }
            }
        } else {
            filterRoutes = []
            if (whitelist.indexOf(to.path) !== -1 ) {
                next()
            } else {
                next({ path: `/internal/login?redirect=${to.path}`, replace: true })
                NProgress.done()
            }
        }
    }else{
        let hasToken = null
        let dayChecked = localStorage.getItem('dayChecked')
        if (dayChecked == 'true') {
            hasToken = localStorage.getItem('token');
        }else {
            hasToken = sessionStorage.getItem('token');
        }
        console.log('hasToken', hasToken)
        if (hasToken) {
            console.log('to.path1', to.path)
    
            if (to.path === '/login') {
                next()
                NProgress.done()
            } else {
                console.log('filterRoutes', filterRoutes)
    
                if (filterRoutes.length == 0) {
                    // let getjurisdictionlist = store.getters['login/getjurisdiction'];
                    // let filterlist = await  store.dispatch('login/generateRoutes',getjurisdictionlist)
                    router["options"].routes = [...constRouters, ...permissonRoutes];
                    filterRoutes = [...constRouters, ...permissonRoutes];
                    router.addRoutes(filterRoutes);
                    next({
                        name: to.name,
                        path: to.path,
                        hash: to.hash,
                        query: to.query,
                        params: to.params,
                        append: false,
                        replace: true
                    });
                } else {
                    next()
                }
            }
        } else {
            filterRoutes = []
            console.log('to.path2', to.path)
            if (whitelist.indexOf(to.path) !== -1 ) {
                next()
            } else {
                next({ path: `/login?redirect=${to.path}`, replace: true })
                NProgress.done()
            }
        }
    }
    


})

router.afterEach((to, from) => {
    setTimeout(() => {
        let el = document.querySelector('.el-main')
        // el.scrollTo(0,0);
    }, 50);
    // 
    NProgress.done();
});

// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
    const pattern = /Loading chunk/g
    const isChunkLoadFailed = error.message.match(pattern)
    const targetPath = (router as any).history.pending.fullPath
    if (isChunkLoadFailed && error.type === 'missing') {
        router.push(targetPath)
    }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.ts